export type PasswordStrength = "weak" | "medium" | "strong";

export function validatePassword(password: string): {
  valid: boolean;
  errors: string[];
  strength: PasswordStrength;
} {
  const checks = [
    { valid: password.length >= 12, message: "Use at least 12 characters." },
    { valid: /[a-z]/.test(password), message: "Add a lowercase letter." },
    { valid: /[A-Z]/.test(password), message: "Add an uppercase letter." },
    { valid: /\d/.test(password), message: "Add a number." },
    {
      valid: /[^A-Za-z0-9]/.test(password),
      message: "Add a symbol.",
    },
  ];
  const passed = checks.filter((check) => check.valid).length;

  return {
    valid: checks.every((check) => check.valid),
    errors: checks
      .filter((check) => !check.valid)
      .map((check) => check.message),
    strength: passed <= 2 ? "weak" : passed <= 4 ? "medium" : "strong",
  };
}
